import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import HeaderComponent from '../common/header.component';

const styles = theme => ({
  contentWrapper: {
    margin: (theme.spacing.unit * 2),
  },
  bottomPadding: {
    paddingBottom: '100px',
  },
});

const MainPageComponent = ({ children, classes, projectView, title }) => (
  <div className={classes.bottomPadding}>
    <HeaderComponent projectView={projectView} title={title}/>
    <div className={classes.contentWrapper}>
      {children}
    </div>
  </div>
);

MainPageComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(MainPageComponent);
